import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getTeamDetails } from '../../../actions/teamActions';

import TeamTable from './TeamTable';
import CreateTeam from './CreateTeam';

class Teams extends Component {
  static propTypes = {
    accountDetail: PropTypes.instanceOf(Object),
    setActivePage: PropTypes.func,
    updatedActivePage: PropTypes.func,
    activePage: PropTypes.string,
    hasAccess: PropTypes.any,
  };

  static defaultProps = {
    activePage: 'TEAM',
    accountDetail: {},
    hasAccess: 0,
  };

  state = {
    selectedTeam: {},
  };

  handleAddTeam = team => {
    if (team) {
      getTeamDetails(team.id).then(response => {
        if (response) {
          const users = _.isEmpty(response.users)
            ? []
            : _.sortBy(response.users, o => o.firstName);
          this.setState(
            {
              selectedTeam: {
                ...response,
                users,
              },
            },
            () => {
              this.props.setActivePage('DETAIL');
            }
          );
        } else {
          console.log('Something went wrong on the Team details');
        }
      });
    } else {
      this.setState(
        {
          selectedTeam: {},
        },
        () => {
          this.props.setActivePage('DETAIL');
        }
      );
    }
  };

  backToTeamTable = () => {
    this.setState({ selectedTeam: {} }, () => {
      this.props.setActivePage('TEAM');
    });
  };

  renderContent = () => {
    const { selectedTeam } = this.state;
    const { activePage } = this.props;
    const users = _.isEmpty(this.props.accountDetail.users)
      ? []
      : _.sortBy(this.props.accountDetail.users, o => o.firstName);

    const accountDetail = {
      ...this.props.accountDetail,
      users,
    };

    if (activePage === 'TEAM') {
      return (
        <div className="accounts-roles-listing">
          <div className="accounts-roles-header">
            <button
              onClick={() => this.handleAddTeam()}
              disabled={!this.props.hasAccess}
              className="accounts-details-card-button"
            >
              <span>Add Team</span>
            </button>
          </div>
          {_.isEmpty(accountDetail.teams) ? (
            <div className="no-result-message">
              There are no team currently created to this account. Please click
              on <strong>Add team</strong> above to create team.
            </div>
          ) : (
            <TeamTable
              accountDetail={accountDetail}
              handleAddTeam={this.handleAddTeam}
            />
          )}
        </div>
      );
    } else if (activePage === 'DETAIL') {
      return (
        <CreateTeam
          selectedTeam={selectedTeam}
          handleBack={this.backToTeamTable}
          accountDetail={accountDetail}
          teamUsers={selectedTeam.users || []}
          updatedActivePage={this.props.updatedActivePage}
          hasAccess={this.props.hasAccess}
        />
      );
    }
    return null;
  };

  render() {
    return (
      <div className="accounts-roles">
        {this.renderContent()}
      </div>
    );
  }
}

export default Teams;
